export const timezoneToLanguage = {
	// French-speaking regions
	"Europe/Paris": "fr",
	"Europe/Brussels": "fr",
	"Europe/Monaco": "fr",
	"Africa/Dakar": "fr",
	"Africa/Algiers": "fr",
	"Africa/Tunis": "fr",
	"Africa/Libreville": "fr",
	"Africa/Brazzaville": "fr",
	"Africa/Kinshasa": "fr",
	"Africa/Porto-Novo": "fr",
	"Africa/Niamey": "fr",
	"Africa/Ouagadougou": "fr",
	"Africa/Lome": "fr",
	"Africa/Conakry": "fr",
	"Africa/Malabo": "fr",
	"Africa/Douala": "fr",
	"Africa/Bangui": "fr",
	"Africa/Ndjamena": "fr",
	"Indian/Reunion": "fr",
	"Indian/Mayotte": "fr",
	"Indian/Mauritius": "fr",
	"America/Montreal": "fr",
	"America/Port-au-Prince": "fr",
	"Europe/Zurich": "fr",
	"Europe/Luxembourg": "fr",
	"Africa/Casablanca": "fr",
	"Africa/Abidjan": "fr",
	"Africa/Bamako": "fr",
	"America/Guadeloupe": "fr",
	"America/Martinique": "fr",
	"America/Cayenne": "fr",
	"Pacific/Tahiti": "fr",

	// Spanish-speaking regions
	"Europe/Madrid": "esp",
	"America/Mexico_City": "esp",
	"America/Argentina/Buenos_Aires": "esp",
	"America/Bogota": "esp",
	"America/Lima": "esp",
	"America/Santiago": "esp",
	"America/Caracas": "esp",
	"America/Guayaquil": "esp",
	"America/Managua": "esp",
	"America/Panama": "esp",
	"America/Asuncion": "esp",
	"America/La_Paz": "esp",
	"America/Havana": "esp",
	"America/Santo_Domingo": "esp",
	"America/San_Salvador": "esp",
	"America/Tegucigalpa": "esp",
	"America/Guatemala": "esp",
	"Atlantic/Canary": "esp",
	"America/El_Salvador": "esp",
	"America/Honduras": "esp",
	"America/Costa_Rica": "esp",
	"America/Quito": "esp",
	"America/Montevideo": "esp",
	"America/Puerto_Rico": "esp",

	// Default to English for all other timezones
	default: "en",
};
